/* RTL product-gallery thumbnail fix - added 2026-06-23 by Claude
   Bug: once the product image gallery reached the last slide, clicking a
   thumbnail could not navigate back to an earlier image (RTL smooth-scroll /
   scroll-snap race in the theme slider). This jumps straight to the chosen
   slide instead, which works reliably in both directions.
   To remove: delete this file and its <script> include in layout/theme.liquid. */
(function () {
  function findSlider(btn) {
    var dots = btn.closest('media-dots');
    var id = dots && dots.getAttribute('aria-controls');
    if (id) { var el = document.getElementById(id); if (el) return el; }
    var gallery = btn.closest('media-gallery');
    return gallery ? gallery.querySelector('slider-element') : null;
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('button.product__thumbnail') : null;
    if (!btn || !btn.dataset.mediaId) return;
    var slider = findSlider(btn);
    if (!slider) return;
    var slide = slider.querySelector('.product__media[data-media-id="' + btn.dataset.mediaId + '"]');
    if (!slide) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    var prevSnap = slider.style.scrollSnapType;
    var prevBehavior = slider.style.scrollBehavior;
    slider.style.scrollSnapType = 'none';
    slider.style.scrollBehavior = 'auto';
    slider.scrollLeft = slide.offsetLeft;
    requestAnimationFrame(function () {
      slider.style.scrollSnapType = prevSnap;
      slider.style.scrollBehavior = prevBehavior;
    });
  }, true);
})();
